// The consent audit surface currently lives on the account detail page; keeping its identity
// here means moving it (e.g. to a Privacy section) only changes where the panel is mounted.
export const i18nRoot = 'account.account-detail.consentAudit';
